import { Button, Flex, Row } from 'antd';
import useWepapp from "../hook/useWepapp";
import { useMediaQuery } from "react-responsive";
const { Outlet } = require("react-router-dom")

const DetailComponent = ({
    complete = () => { },
    navBar = () => { }
}) => {
    const { goToMenu = () => { } } = useWepapp()
    return (
        <Flex style={{ height: "90vh", width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", backgroundColor: "#FCF9F6" }}>
            <Row style={{ textAlign: "center" }}>
                {complete()}
            </Row>
            {navBar()}
        </Flex>

    )
}
export default DetailComponent;

